import store from '../store/index'
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import(/* webpackChunkName: "Home" */ "../views/Home.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "Login" */ "../views/Login.vue"),
    },
    {
        path: '/request',
        name: 'Request',
        component: () =>
            import(/* webpackChunkName: "Request" */ "../views/Request.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: '/logout',
        name: 'Logout',
        component: () =>
            import(/* webpackChunkName: "Logout" */ "../views/Logout.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: '/usuarios',
        name: 'Usuarios',
        component: () =>
            import(/* webpackChunkName: "Usuarios" */ "../views/Usuarios.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: '/videos',
        name: 'videos',
        component: () =>
            import(/* webpackChunkName: "Videos" */ "../views/Videos.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: '/unidades',
        name: 'Unidades',
        component: () =>
            import(/* webpackChunkName: "Unidades" */ "../views/Unidades.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: '/unidadevideo',
        name: 'UnidadeVideo',
        component: () =>
            import(/* webpackChunkName: "UnidadeVideo" */ "../views/UnidadeVideo.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: '/realtime',
        name: 'Tempo Real',
        component: () =>
            import(/* webpackChunkName: "Exec" */ "../views/Exec.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: '/redirecionamentos',
        name: 'Redirecionamentos',
        component: () =>
            import(/* webpackChunkName: "Redirecionamentos" */ "../views/Redirecionamentos.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: '/repredi',
        name: 'ReportRedi',
        component: () =>
            import(/* webpackChunkName: "ReportRedi" */ "../views/ReportRedi.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () =>
            import(/* webpackChunkName: "NotFound" */ "../views/NotFound.vue"),
        meta: { requiresAuth: false }
    },
]
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    let logged = store.getters.getLogged
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (logged) {
            store.dispatch('setShowMenu', true);
            next()
        } else {
            next({ path: '/login' })
        }
    } else {
        next()
    }

})

export default router